<template>
  <!-- v-if="searchStore.user.is_staff" -->
  <div id="Dashboard"  class="container is-fluid">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">
    
    <!-- Header -->
    <HeroContainer title="Rules Dashboard" />

    <section id="dashboard_data">
      <DataTable2 
        v-if="queryData.data.length > 0"
        :raw_data="queryData"
        :name="'dash_rules_summary'"
      />
    </section>
  </div>
</template>

<style scoped>
  section#filters>div>div{
    margin-top:1em;
  }
</style>

<script>
import DataTable2 from '@/components/shared/DataTable2.vue';
import {
  DASHBOARD_RULES_SUMMARY
} from '@/data/url';
import HeroContainer from '@/components/shared/HeroContainer.vue';

export default {
  name: 'DashboardRules',
  components: {
    DataTable2,
    HeroContainer,
  },
  data: function(){
    return {
      queryDataRaw: [],
    };
  },
  computed:{
    selected_rule_id(){
      if (this.selected_index < 0){
        return 0
      }
      let rule_id = this.rules[this.selected_index].id
      return rule_id
    },
    queryData(){
      let raw_query = [...this.queryDataRaw]
      if(Object.keys(raw_query).length == 0){
        return {site:'',data:[]}
      }
      return {site:'', data: raw_query,}
    },
  },
  mounted: function(){
    this.ajax_get_rules()
  },
  methods: {    
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    ajax_get_rules(){
      let url = DASHBOARD_RULES_SUMMARY
      this.set_searching(true)
      let this_vue = this
      function set_data(this_vue, data){
        this_vue.queryDataRaw = data
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({}),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_data(this_vue, res.data)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
  }
};

</script>
